<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>车队名称：</p>
        <el-input v-model="teamIpt" size="mini" style="width:150px" placeholder="请输入车队名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>任务编号：</p>
        <el-input v-model="taskIpt" size="mini" style="width:150px" placeholder="请输入任务编号"/>
      </div>
      <div class="navContainer" style="width: 480px">
        <p>装车时间：</p>
        <el-date-picker
          v-model="timeIpt"
          type="daterange"
          size="mini"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始装车时间"
          end-placeholder="结束装车时间"/>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="fleetName" label="车队名称" align="center"/>
          <el-table-column prop="taskCode" label="任务编号" align="center"/>
          <el-table-column prop="entruckTime" label="装车时间" align="center"/>
          <el-table-column prop="fleetCount" label="装车数量" align="center"/>
          <el-table-column label="装车地" width="200px" align="center">
            <template slot-scope="scope">
              <span :style="{'paddingRight':(scope.row.startType==1?'30px':'0px')}">{{scope.row.startName}}</span>
              <i v-if="scope.row.startType==1" class="port-icon" :title="scope.row.startPortName">港</i>
            </template>
          </el-table-column>
          <el-table-column label="交车地" width="200px" align="center">
            <template slot-scope="scope">
              <span :style="{'paddingRight':(scope.row.deliveryType==1?'30px':'0px')}">{{scope.row.deliveryName}}</span>
              <i v-if="scope.row.deliveryType==1" class="port-icon" :title="scope.row.deliveryPortName">港</i>
            </template>
          </el-table-column>
          <el-table-column prop="driverState" label="分配车辆状态" align="center">
            <div slot-scope="scope">{{getCarState(scope.row.carCount)}}</div>
          </el-table-column>
          <el-table-column prop="state" label="任务状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
                <el-button v-if="scope.row.status==0" size="mini" class="resetBtn" type="primary" @click="distribution(scope.row.id)">分配运输车</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='750px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>调配信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">车队名称：</span>
              <span>{{detailData.fleetName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">任务编号：</span>
              <span>{{detailData.taskCode}}</span>
            </div>
            <div class="baseInfoContentItem" style="margin-bottom: 0;">
              <span class="span1">起运地址：</span>
              <span>{{detailData.startName}}</span>
              <span v-if="detailData.startType==1">【{{detailData.startPortName}}】</span>
              <div class="addressItem">{{detailData.startDetail}}</div>
            </div>
            <div class="baseInfoContentItem" style="margin-bottom: 0;">
              <span class="span1">交车地址：</span>
              <span>{{detailData.deliveryName}}</span>
              <span v-if="detailData.deliveryType==1">【{{detailData.deliveryPortName}}】</span>
              <div class="addressItem">{{detailData.deliveryDetail}}</div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">装车时间：</span>
              <span>{{detailData.entruckTime}}</span>
            </div>
            <!-- <div v-if="detailData.status==2" class="baseInfoContentItem">
              <span class="span1">交车时间：</span>
              <span>{{detailData.entruckTime}}</span>
            </div> -->
            <div class="baseInfoContentItem">
              <span class="span1">托运数量：</span>
              <span>{{detailData.fleetCount}}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>托运车信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="driverData" border style="width: 100%">
              <el-table-column label="序号" align="center" width="50px" type="index"/>
              <el-table-column prop="taskNumber" label="司机任务编号" align="center"/>
              <el-table-column prop="truckName" label="车牌号" align="center"/>
              <!-- <el-table-column prop="brand" label="车辆类型" align="center"/> -->
              <el-table-column prop="driverName" label="司机姓名" align="center"/>
              <el-table-column prop="entruckDate" :formatter="getDate" label="装车时间" align="center"/>
              <el-table-column prop="deliveryDate" :formatter="getDate" label="交车时间" align="center"/>
              <el-table-column label="车辆状态" align="center">
                <div slot-scope="scope">{{getCarState2(scope.row.status)}}</div>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>委托车信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="carData" border style="width: 100%">
              <!-- <el-table-column prop="billNumber" label="运单编号" align="center" /> -->
              <el-table-column prop="batchNumber" label="批次号" width="110" align="center"/>
              <el-table-column prop="waybillNo" label="运单编号" width="110" align="center"/>
              <el-table-column prop="frameNumber" label="车架号" width="110" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
              <!-- <el-table-column prop="config" label="配置" align="center"/> -->
              <el-table-column prop="color" label="颜色" align="center"/>
              <!-- <el-table-column prop="weight" label="重量" align="center"/>
              <el-table-column prop="lwh" label="长宽高" align="center"/> -->
              <el-table-column prop="fileName" label="附件" align="center"/>
              <el-table-column prop="stateStr" label="状态" align="center"/>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作记录</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border style="width: 100%">
              <el-table-column prop="createTime" label="操作时间" align="center">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="分配运输车" :visible.sync="driverDialogVisible" width='650px' height="500" center @close="distributionClose">
      <div class="detail2">
        <el-form ref="distribution" label-width="110px" :rules="distriRules" class="demo-ruleForm" size="mini" :model="distriForm">
          <div class="baseInfo">
            <div class="baseInfoTitle">
              <div class="line"/>
              <span>基础信息</span>
            </div>
            <div class="baseInfoContent">
              <el-form-item label="任务编号:">
                {{detailData.taskCode}}
              </el-form-item>
              <el-form-item label="运输供应商:">
                {{detailData.fleetName }}
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="运输状态:">
                    {{detailData.status |statusFormat}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="托运数量:">
                    {{detailData.fleetCount}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="起始地:" style="margin-bottom: 0">
                <span>{{detailData.startName}}</span>
                <span v-if="detailData.startType==1">【{{detailData.startPortName}}】</span>
                <div class="addressItem">{{detailData.startDetail}}</div>
              </el-form-item>
              <div style="color: #999999;width: 430px;margin-left: 70px">
                {{detailData.startingPlace}}
              </div>
              <el-form-item label="交车地:" style="margin-bottom: 0">
                <span>{{detailData.deliveryName}}</span>
                <span v-if="detailData.deliveryType==1">【{{detailData.deliveryPortName}}】</span>
                <div class="addressItem">{{detailData.deliveryDetail}}</div>
              </el-form-item>
              <div style="color: #999999;width: 430px;margin-left: 70px">
                {{detailData.deliveryPlace}}
              </div>
              <el-form-item label="运输时间:">
                {{detailData.entruckTime}}
              </el-form-item>

            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>已选择车辆</span>
            </div>
            <div class="operationTable">
              <el-table
                :data="detailData.driverList"
                style="width: 100%"
                border
                :header-cell-style="{color:'#7F7F7F','font-size':'13px',height:'35px'}"
                :cell-style="{'color':'#7F7F7F','font-size':'13px'}"
                ref="selectCar"
                >
                <el-table-column type="index" label="序号" align="center"></el-table-column>
                <el-table-column prop="truckName" label="车牌号" align="center" width="200px">
                  <template slot-scope="scope" >
                    {{scope.row.truckName}}
                  </template>
                </el-table-column>
                <el-table-column prop="driverName" label="司机姓名" align="center" width=""/>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-error" @click="deles(scope.$index)" style="font-size: 26px;"></i>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>选择车辆</span>
            </div>
            <div class="operationTable">
              <el-table
                :data="distriForm.vehicleData"
                style="width: 100%"
                border
                :header-cell-style="{color:'#7F7F7F','font-size':'13px',height:'35px'}"
                :cell-style="{'color':'#7F7F7F','font-size':'13px'}"
                ref="selectCar"

              >
<!--                @selection-change="handleSelectionChange">-->
                <el-table-column type="index" label="序号" align="center"></el-table-column>
<!--                <el-table-column-->
<!--                  type="selection"-->
<!--                  align="center"-->
<!--                  width="70px">-->
<!--                </el-table-column>-->
                <el-table-column prop="truckName" label="车牌号" align="center" width="200px">
                  <template slot-scope="scope" >
<!--                    <el-form-item :prop="`vehicleData[${scope.$index}].license`" :rules="distriRules.license" label-width="opx">-->
<!--                      <el-select size="mini" filterable v-model="scope.row.license" @change="licenseChange(scope.row.license,scope.$index)" value-key="id">-->
<!--                        <el-option v-for="(item,index) in supplierCarList" :key="item.id" :label="item.license" :value="item" placeholder="请选择车牌号"></el-option>-->
<!--                      </el-select>-->
<!--                    </el-form-item>-->
                    {{scope.row.truckName}}
                  </template>
                </el-table-column>
                <el-table-column prop="driverName" label="司机姓名" align="center" width=""/>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-circle-plus" @click="addMaterial(scope.$index)" style="font-size: 26px;"></i>
                  </template>
                </el-table-column>
<!--                <div slot="append" style="padding:9px">-->

<!--                  <el-button type="warning" icon="el-icon-plus" circle style="padding: 4px;"-->
<!--                             @click="addMaterial">-->
<!--                  </el-button>-->
<!--                  <span style="margin:10px">添加车辆</span>-->
<!--                </div>-->
              </el-table>
            </div>
            <div style="margin-top: 15px;width: 100%;display:flex;align-items:center;justify-content: center">
              <el-button class="searchBtn" :loading="addLoad" @click="addClick2" size="small">确定</el-button>
              <el-button class="resetBtn" @click="distributionClose" size="small">关闭</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    entruckInfoCvSelectSupplierByDeployId,
    vehicleDeployFleetCvDetail,
    vehicleDeployFleetCvPageList,
    vehicleDeployInfoCvAddTransportVehicle, vehicleDeploygetDistributionByCar
  } from "@/service/vehiclelog";
import {formatDateTime} from "@/config/mUtils";

export default {
  components: {
  },
  data() {
    return {
      taskIpt:'',
      teamIpt:'',
      timeIpt:'',
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{},
      carData:[],
      driverData:[],
      operationData:[],
      dialogTitle:'',
      dialogVisible:false,
      addLoad:false,
      steps:0,
      dialogWidth:'',
      addTable:[],
      restaurants:[],
      submitTable:[],
      driverDialogVisible:false,
      distriForm:{
        fleet:'',
        vehicleData:[
          {truckName:'',vehicleType:'',vehicleStatus:'',driverName:'',driverTelephone:''}
        ]
      },

      supplierCarList:[],
      distriRules:{
        license:[
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ],
        vehicleType:[
          { required: true, message: '请选择车辆类型', trigger: 'blur' },
        ],
        fleet:[
          { required: true, message: '请选择车队', trigger: 'blur' },
        ],
        vehicleStatus:[
          { required: true, message: '请选择车辆状态', trigger: 'blur' },
        ],
        driverName:[
          { required: true, message: '请输入司机姓名', trigger: 'blur' },
        ],
        driverTelephone:[
          { required: true, message: '请输入司机电话', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
    getCarState() {
      return function (value) {
        if (value>0) return '已分配';
        else return  '未分配'
      };
    },
    getCarState2() {
      return function (state) {
        switch (state) {
          case 0:
            return '待开始'
          case 1:
            return '执行中'
          case 2:
            return '已完成'
        }
      };
    },
    getState() {
      return function (state) {
        switch (state) {
          case 0:
            return '待开始'
          case 1:
            return '执行中'
          case 2:
            return '已完成'
        }
      };
    },
  },
  filters:{
    statusFormat(value){
      switch (value) {
        case 0:
          return '待运输'
        case 1:
          return '运输中'
        case 2:
          return '已完成'
      }
    },
  },
  mounted() {
   // this._vehicleDeployFleetCvPageList();
  },
  methods: {
    async _vehicleDeployFleetCvPageList(){
      const obj = {
        fleetName:this.teamIpt,
        taskCode:this.taskIpt,
        startTime:this.timeIpt[0]?this.timeIpt[0]:'',
        endTime:this.timeIpt[1]?this.timeIpt[1]:'',
        rows:this.size,
        page:this.page,
      };
      this.tableLoad=true;
      const res = await vehicleDeployFleetCvPageList(obj);
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._vehicleDeployFleetCvPageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._vehicleDeployFleetCvPageList();
    },
    async detailClick(id) {
      this.detailDialogVisible = true;
      const res = await vehicleDeployFleetCvDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData=res.data;
      // this.driverData=res.data.carDocList;
      this.driverData=res.data.driverList;
      this.carData=res.data.carList;
      this.operationData=res.data.operateRecordList;
    },
    searchBtn(){
      this.page = 1;
      this._vehicleDeployFleetCvPageList();
    },
    resetBtn(){
      this.taskIpt='';
      this.teamIpt='';
      this.timeIpt='';
    },
    async addClick2(){
      this.$refs.distribution.validate(async (valid) => {
        if (valid){
          this.addLoad = true;
          const res = await vehicleDeployInfoCvAddTransportVehicle({
            id:this.detailData.id,
            // deployFleetId:this.distriForm.fleet,
            //上传已选择的车辆
            driverList: this.detailData.driverList.map(item=>{
              return{
                truckId:item.truckId,
                truckName:item.truckName,
                driverName:item.driverName,
                driverId:item.driverId
              }
            })
          });
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.driverDialogVisible=false;
          await this._vehicleDeployInfoCvPageList();

        }else {

        }
      })


    },
    distributionClose(){
      this.driverDialogVisible=false
      this.detailData = {}
      this.distriForm={
        fleet:'',
        vehicleData:[
          {truckName:'',vehicleType:'',vehicleStatus:'',driverName:'',driverTelephone:''}
        ]
      }
    },
    async distribution(id){
      this.driverDialogVisible=true;
      const res = await vehicleDeploygetDistributionByCar({distributionId:id});
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData=res.data;
      //下拉数据  车list
      this.supplierCarList = res.data.carDocList
      //修改数据结构 ，两个保持一致
      this.distriForm.vehicleData = res.data.carDocList.map(item=>{
        return{
          driverId:item.driverId,
          driverName :item.driverName,
          truckId: item.id,
          truckName: item.license
        }
      })
      //已选择的车辆
      this.detailData.driverList.map(item =>{
        return{
          driverId:item.driverId,
          driverName :item.driverName,
          truckId: item.truckId,
          truckName: item.truckName
        }
      })
    },
    //下拉事件
    licenseChange(value,index){
      this.distriForm.vehicleData[index].driverName= ''
      //判断是否找到绑定的司机
      let flag = false
      //循环司机 得到司机数据
      this.detailData.driverList.forEach((item,indexx)=>{
        if (item.truckId ===value.id){
          this.distriForm.vehicleData[index].driverName = item.driverName
          // 保存
          this.distriForm.vehicleData[index].id = item.truckId
          flag = true
        }
      })
      if (!flag) {
        this.$message.warning('没有司机绑定该运输车')
        this.distriForm.vehicleData[index].license = ''
      }

    },
    deles(index){
      //已选择车辆 添加到 未选
      let arr  =this.detailData.driverList.splice(index,1)
      arr.forEach(item=>{
        this.distriForm.vehicleData.push(item)
      })
    },
    addMaterial(index){
      //未选择车辆 添加到 已选
      let arr = this.distriForm.vehicleData.splice(index,1)
      arr.forEach(item=>{
        this.detailData.driverList.push(item)
      })
    },
    handleSelectionChange(val){
      console.log(val)
      //循环选中的数据
      val.forEach(item=>{
        //先判断是否为空数组 跟以选中的数据做对比  判断 driverId是否相同
        this.detailData.driverList.length !==0 ?this.detailData.driverList.forEach(cal =>{
          // 如果相同 就不让勾选
          if (item.driverId ===cal.driverId){
            // 使用表格原数据进行赛选
            this.$refs.selectCar.toggleRowSelection(this.distriForm.vehicleData.find(item=>{
              return cal.driverId ===item.driverId
            }),false)
            this.$message.warning("车辆已选择")
          }else {
            this.submitTable = val
            console.log(this.submitTable)
          }
        }):this.submitTable = val
      })
    },

    // 时间长度处理
    getDate(row,column,cellValue) {
      if(cellValue) return cellValue.substring(0,10);
      else return ''
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .addressItem{
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            // margin-bottom: 10px;
            margin-bottom: 0px;
            margin-left: 70px;
          }
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }

      }

      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;


      }
    }
  }
  ::v-deep.detail2{
    width: 100%;
    padding: 10px 0 20px 20px;
    // max-height:80vh;
    max-height: 500px;
    overflow: auto;
    .tableAddBtnContainer{
      border: 1px solid #EBEEF5;;
      border-top-style: none;
      width: 100%;
      //height: 35px;
      display: flex;
      align-items: center;
      //padding-left: 15px;
      ::v-deep{
        .el-select .el-input.is-focus .el-input__inner{
          border-color: #DCDFE6;
        }
        .el-select .el-input__inner:focus{
          border-color: #DCDFE6;
        }
      }
      .AddContainer{
        display: flex;
        align-items: center;
        &:hover{
          cursor: pointer;
        }
      }
      img{
        object-fit: cover;
        margin-right: 5px;
      }
      p{
        font-size: 13px;
        color: #F59A23;
        font-family: 'Arial Normal', 'Arial', sans-serif;
      }
      .addBtn{
        outline:none;
        width: 100%;
        color: #3d3d3d;
        background-color: #fff;
        border: 1px solid #CECECE;
        font-size: 12px;
        height:20px;
        &:hover{
          cursor: pointer;
        }
      }
    }
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        .addressItem{
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          margin-bottom: 10px;
          margin-left: 70px;
        }
        .el-form-item__label{
          font-weight: 700;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      .el-form-item{
        margin-bottom: 0!important;
      }
      .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after{
        color: #606266;
        content: "全选";
        font-size: 12px;
        margin-left: 2px;

      }
      ::v-deep{
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;


      }
    }
    ::v-deep{
      .el-input--mini .el-input__inner{
        width: 100%;
      }
      .cell{
        font-size: 10px;
        padding:0;
      }
      .el-table td, .el-table th{
        padding:0;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-table .ui-warning-row {
    background: #DDD!important;
  }
  .el-table .ui-warning-row .cell{
    color: red;
  }
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-table td, .el-table th {
    padding: 0px;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
  .baseInfoContentItem {
    margin-bottom: 10px !important;
  }
}
i.port-icon {
  float: right;
  margin: 1.5px 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
  background: red;
  color: #fff;
  border-radius: 50%;
}
</style>
